var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.url)?_c('RedocComponent',{attrs:{"specUrl":_vm.url,"options":{ scrollYOffset: 50 }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }